module.exports = __webpack_public_path__ + "static/media/icon-arrow-right.210c039e.svg";